import React, { useEffect, useRef, useState } from 'react';
import { AppBar, Box, Toolbar, Typography, Menu, Container, Button, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import { BiSupport } from "react-icons/bi";
import { IoIosArrowDown } from "react-icons/io";
import browsecatIcon from "../assests/browsecatIcon.png";
import CategoryListCard from "./CategoryListCard";
// import dealsIcon from "../assests/dealsIcon.png";

const MainNav = () => {
  const menuStyle = {
    my: 2,
    color: "#000000",
    fontFamily: `"Outfit", sans-serif`,
    fontWeight: 400,
    fontSize: { sm: "16px", lg: "18px", md: "16px" },
    textTransform: "none",
    mx: { xs: 0, sm: 1, md: 0, lg: 2 }, // Responsive margin
    display: "flex",
    alignItems: "center",
    gap: "5px",
    "& img": {},
  };

  const [anchorElNav, setAnchorElNav] = React.useState(null);

  // const handleOpenNavMenu = (event) => {
  //   setAnchorElNav(event.currentTarget);
  // };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (componentRef.current && !componentRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [componentRef]);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <AppBar
      position="static"
      style={{
        background: "transparent",
        boxShadow: "none",
        padding: "10px 0", // Adjusted padding for consistency
        fontFamily: `"Outfit", sans-serif`,
        borderTop: "1px solid #ECECEC",
        borderBottom: "1px solid #ECECEC",
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1,
              position: "relative",
              width: "8%",
            }}
            className="browseCat"
          >
            <Button
              onClick={toggleVisibility}
              sx={{
                background: " #008BFF",
                borderRadius: "5px",
                width: "255px",
                height: "44px",
                color: "#fff",
                textTransform: "capitalize",
                gap: "12px",
              }}
            >
              <img src={browsecatIcon} alt="icon" />
              Browse All Categories <IoIosArrowDown />
            </Button>
            {isVisible && (
              <Box
                ref={componentRef}
                onClick={(e) => e.stopPropagation()}
                sx={{
                  position: "absolute",
                  top: "45px",
                  left: 0,
                  zIndex: "99",
                  width: "319px",
                }}
              >
                <CategoryListCard setIsVisible={setIsVisible} />
              </Box>
            )}
          </Box>

          {/* Centered navigation links */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* <Button
              component={Link}
              to="/"
              onClick={handleCloseNavMenu}
              sx={menuStyle}
            >
              <img src={dealsIcon} alt="icon" /> Deals
            </Button> */}
            <Button
              component={Link}
              to="/"
              onClick={handleCloseNavMenu}
              sx={menuStyle}
            >
              Home
            </Button>
            <Button
              component={Link}
              to="/aboutus"
              onClick={handleCloseNavMenu}
              sx={menuStyle}
            >
              About
            </Button>
            <Button
              component={Link}
              to="/shop"
              onClick={handleCloseNavMenu}
              sx={menuStyle}
            >
              Shop
            </Button>
            <Button
              component={Link}
              to="/vendor"
              onClick={handleCloseNavMenu}
              sx={menuStyle}
            >
              Vendors
            </Button>
            {/* <Button
              component={Link}
              to="/"
              onClick={handleCloseNavMenu}
              sx={menuStyle}
            >
              Blog
            </Button> */}
            <Button
              component={Link}
              to="/contactus"
              onClick={handleCloseNavMenu}
              sx={menuStyle}
            >
              Contact
            </Button>
            {/* {pages.map((page) => (
              <Button
                key={page.name}
                component={Link}
                to={page.path}
                onClick={handleCloseNavMenu}
                sx={{
                  my: 2,
                  color: "#000000",
                  display: "block",
                  fontFamily: `"Outfit", sans-serif`,
                  fontWeight: 400,
                  fontSize: { sm: "16px", lg: "18px", md: "16px" },
                  textTransform: "none",
                  mx: { xs: 0, sm: 1, md: 0, lg: 2 }, // Responsive margin
                }}
              >
                {page.name}
              </Button>
            ))} */}
          </Box>

          {/* support button on the right */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                "& span a": {
                  fontSize: "26px",
                  lineHeight: "26px",
                  fontWeight: "700",
                  fontFamily: `'Quicksand', sans-serif`,
                  color: "#008BFF",
                },
                "& span span": {
                  fontSize: "12px",
                  lineHeight: "12px",
                  fontWeight: "500",
                  fontFamily: `'Lato', sans-serif`,
                  color: "#7E7E7E",
                  display: "block",
                },
                "& svg": {
                  color: "#253D4E",
                  fontSize: "44px",
                },
              }}
            >
              <BiSupport />
              <div className="text-[20px] flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <a href="mailto:waleed@lifelinems.com" className="hover:underline">
                    waleed@lifelinems.com
                  </a>
                </div>
                <div className="flex items-center gap-2">
                  <a href="tel:3133531265" className="hover:underline">
                    313-353-1265
                  </a>
                </div>
              </div>

            </Box>

            {/* Mobile menu icon */}
            {/* <IconButton
              size="large"
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              sx={{ color: "black", display: { xs: "flex", md: "none" } }}
            >
              <MenuIcon />
            </IconButton> */}
          </Box>

          {/* Mobile menu */}
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiPaper-root": {
                width: "90%", // Full-width on mobile
                maxWidth: "90%",
              },
            }}
          >
            {/* {pages.map((page) => ( */}
            {/* <MenuItem component={Link}>
              <Typography textAlign="center">
                <img src={dealsIcon} alt="icon" />
                Deals
              </Typography>
            </MenuItem> */}
            <MenuItem
              // key={page.name}
              onClick={handleCloseNavMenu}
              component={Link}
            // to={page.path}
            >
              <Typography textAlign="center">xssdsa</Typography>
            </MenuItem>
            {/* ))} */}
            <MenuItem
              onClick={handleCloseNavMenu}
              component={Link}
              to="/donate"
            >
              <Button
                variant="contained"
                sx={{
                  background: "#A6000E",
                  fontFamily: `"Outfit", sans-serif`,
                  fontWeight: 500,
                  fontSize: "16px",
                  width: "100%", // Full-width button on mobile
                  margin: "10px 0",
                }}
              >
                Donate Now
              </Button>
            </MenuItem>
          </Menu>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default MainNav;
